<template>
  <el-dialog
    :visible.sync="dialogVisible"
    title="处理后图片预览"
    width="980px"
    :close-on-click-modal="false"
  >
    <div class="preview-shell" v-if="taskDetail">
      <div class="preview-summary">
        <div v-for="item in summaryCards" :key="item.label" class="summary-card">
          <div class="summary-label">{{ item.label }}</div>
          <div class="summary-value">{{ item.value }}</div>
        </div>
      </div>

      <div class="preview-tip">以下为按冻结规则和输出参数生成的原型模拟预览，用于核对尺寸、顺序和替换位置。</div>

      <div class="preview-grid">
        <div v-for="item in taskDetail.processedPreviewRows" :key="item.fileName" class="preview-card">
          <div class="preview-canvas">
            <span class="preview-kind">{{ item.imageType }}</span>
            <strong>处理效果</strong>
            <span>{{ item.imageSizeText }}</span>
          </div>
          <div class="preview-meta">
            <strong :title="item.fileName">{{ item.fileName }}</strong>
            <span>序号：{{ item.sequenceNo }}</span>
            <span>格式：{{ item.fileFormat }}</span>
            <span>容量：{{ item.fileSizeText }}</span>
            <span>替换位置：{{ item.replacePositionText }}</span>
            <span>输出校验：<b class="status-ok">{{ item.verifyStatusText }}</b></span>
          </div>
        </div>
      </div>
    </div>

    <div slot="footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'ProcessedPreviewDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    taskDetail: {
      type: Object,
      default: null
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (val) {
        this.$emit('update:visible', val)
      }
    },
    summaryCards () {
      if (!this.taskDetail) return []
      return [
        { label: '任务编号', value: this.taskDetail.taskId },
        { label: '平台组/店铺', value: `${this.taskDetail.platformGroupLabel}/${this.taskDetail.storeName}` },
        { label: '商品/平台商品编码', value: `${this.taskDetail.productCode}/${this.taskDetail.platformGoodsCode}` },
        { label: '图片类型', value: this.taskDetail.imageType },
        { label: '冻结规则版本', value: this.taskDetail.versionNo || 'DSL2606002-1.0' },
        { label: '输出图片数量', value: this.taskDetail.previewCount }
      ]
    }
  }
}
</script>

<style lang="stylus" scoped>
.preview-shell
  max-height 68vh
  overflow auto

.preview-summary
  display grid
  grid-template-columns repeat(3, minmax(0, 1fr))
  gap 12px
  margin-bottom 12px

.summary-card
  background #fff
  border 1px solid #ebeef5
  border-radius 6px
  padding 12px

.summary-label
  color #909399
  font-size 12px
  margin-bottom 6px

.summary-value
  color #303133
  font-weight 600
  word-break break-all

.preview-tip
  margin-bottom 12px
  padding 10px 12px
  background #f4f8fb
  border-radius 6px
  color #606266

.preview-grid
  display grid
  grid-template-columns repeat(2, minmax(0, 1fr))
  gap 12px

.preview-card
  border 1px solid #ebeef5
  border-radius 6px
  overflow hidden
  background #fff

.preview-canvas
  min-height 180px
  background linear-gradient(135deg, #eef4ff 0%, #f8fbff 100%)
  display flex
  flex-direction column
  align-items center
  justify-content center
  gap 8px
  color #303133

.preview-kind
  color #409eff
  font-size 12px

.preview-meta
  display flex
  flex-direction column
  gap 6px
  padding 12px
  color #606266

.status-ok
  color #67c23a

@media (max-width: 1200px)
  .preview-summary,
  .preview-grid
    grid-template-columns 1fr
</style>
